function collectionItemsInit() {
  const collectionItems = document.querySelectorAll('[data-collection-item]');
  if (!collectionItems) { return; }
  collectionItems.forEach(item => {
    collectionItemInit(item);
  });
}

function collectionItemInit(item) {
  const helpOpen = item.querySelector('[data-collection-item-help-toggle]');
  const helpClose = item.querySelector('[data-collection-item-help-close]');

  if (!helpOpen || !helpClose) { return; }

  helpOpen.addEventListener('click', () => {
    item.classList.add('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });

  helpClose.addEventListener('click', () => {
    item.classList.remove('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  collectionItemsInit();
});

// filter list mobile scroll

function filterListMobileScroll() {
  const filters = document.querySelectorAll('[data-tag-filter]');

  if (!filters) { return; }

  function calcWidth() {
    filters.forEach(filter => {
      const filterList = filter.querySelector('[data-tag-filter-list]');
      const filterListItems = filter.querySelectorAll('[data-tag-filter-list] > li');

      let filterWidth = 0;
      filterListItems.forEach(filterListItem => {
        const itemStyle = filterListItem.currentStyle || window.getComputedStyle(filterListItem);
        filterWidth += filterListItem.offsetWidth + parseFloat(itemStyle.marginRight);
      });

      filterList.style.width = `${filterWidth + 24}px`;
    });
  }

  function resetWidth() {
    filters.forEach(filter => {
      const filterList = filter.querySelector('[data-tag-filter-list]');
      filterList.removeAttribute('style');
    });
  }

  const breakpoint = window.matchMedia('(max-width: 750px)');

  breakpoint.addListener(breakpointCheck);

  function breakpointCheck() {
    if (breakpoint.matches === true) {
      setTimeout(() => {
        calcWidth();
      }, 500);
    } else {
      resetWidth();
    }
  }

  breakpointCheck();
}

document.addEventListener('DOMContentLoaded', () => {
  filterListMobileScroll();
});

document.addEventListener('shopify:section:load', () => {
  filterListMobileScroll();
});

// yotpo reviews

// Check if Yotpo is initialized
function yotpoSliderInit() {
  const reviewsWrapper = document.querySelector('[data-product-reviews]');
  const productReviews = document.querySelector('[data-product-template-reviews]');
  let mySwiper = null;
  const isProductTemplate = (productReviews !== null);

  const yotpoLoaded = setInterval(() => {
    const yotpoWrapper = document.querySelector('.main-widget');
    // If no reviews, add class and bail
    if (yotpoWrapper != null && yotpoWrapper.classList.contains('yotpo-no-reviews')) {
      reviewsWrapper.classList.add('no-reviews');
      clearInterval(yotpoLoaded);
      return;
    }

    // If reviews, make swiper, add click listener
    const yotpoReview = document.querySelector('.yotpo-review');
    if (yotpoReview !== null) {
      rejigLayout();
      rejigReviews();
      mySwiper = makeSwiper();
      disableSwiperOnDesktop();
      reviewLoadedChecker();
      clearInterval(yotpoLoaded);
    }
  }, 100);

  // Cancel interval if no reviews after 10 seconds
  setTimeout(() => {
    clearInterval(yotpoLoaded);
  }, 10000);

  function makeSwiper() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('swiper-container', 'reviews-slider');
    sliderContainer.setAttribute('data-product-reviews-swiper-container', '');
    const sliderWrapper = document.createElement('div');
    sliderWrapper.classList.add('swiper-wrapper');
    sliderContainer.prepend(sliderWrapper);
    yotpoReviews.prepend(sliderContainer);

    initSwiper(sliderContainer);

    const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    if (yotpoReviewsList !== null) {
      const yotpoReviewArrays = [...yotpoReviewsList];
      yotpoReviewArrays.forEach((review) => {
        review.classList.add('swiper-slide');
        mySwiper.appendSlide(review);
      });
    }
    return mySwiper;
  }

  function initSwiper(sliderContainer) {
    const options = {
      slidesPerView: 'auto',
      centeredSlides: false,
      freeMode: true,
      loop: false,
      mousewheel: {
        forceToAxis: true,
        eventsTarget: '.reviews-slider',
        invert: true,
      },
      navigation: {
        nextEl: '.swiper-nav__btn--next',
        prevEl: '.swiper-nav__btn--prev',
      },
    };

    mySwiper = new Swiper(sliderContainer, options);
  }

  function rejigLayout() {
    const bottomLine = reviewsWrapper.querySelector('.yotpo-bottomline');
    const yotopLabel = reviewsWrapper.querySelector('.yotpo-label');
    const yotopLabelClear = yotopLabel.querySelector('.yotpo-clr');
    const writeReviewButton = reviewsWrapper.querySelector('.write-review-button');
    const bottomLineEls = document.querySelectorAll('[data-yotpo-bottomline-container]');

    if (bottomLine == null) { return; }
    bottomLine.classList.remove('pull-left');
    writeReviewButton.classList.remove('pull-right');
    yotopLabelClear.remove();
    yotopLabel.appendChild(bottomLine);
    yotopLabel.appendChild(writeReviewButton);

    if (bottomLineEls == null) { return; }
    const bottomLineClone = bottomLine.cloneNode(true);
    bottomLineEls.forEach(bottomLineEl => {
      bottomLineEl.append(bottomLineClone);
    });
  }

  function rejigReviews() {
    const yotpoReviewsList = document.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    yotpoReviewsList.forEach(review => {
      const reviewHeader = review.querySelector('.yotpo-header');
      const reviewFooter = review.querySelector('.yotpo-footer');
      const reviewStars = review.querySelector('.yotpo-review-stars');
      const reviewStarsClone = reviewStars.cloneNode(true);
      const reviewName = review.querySelector('.yotpo-user-name');
      const reviewNameClone = reviewName.cloneNode(true);
      const reviewVerified = reviewHeader.querySelector('.label-with-tooltip');
      const reviewhelpfulLabel = review.querySelector('.label-helpful');

      if (reviewVerified !== null) {
        const reviewVerifiedClone = reviewVerified.cloneNode(true);
        reviewVerifiedClone.classList.add('verified-buyer');
        reviewFooter.prepend(reviewVerifiedClone);
        reviewVerified.remove();
      }
      reviewHeader.appendChild(reviewStarsClone);
      reviewFooter.prepend(reviewNameClone);

      reviewhelpfulLabel.innerText = 'Was This Helpful?';

      // Cleanup
      reviewName.remove();
      reviewStars.remove();
    });
  }

  function reviewLoadedChecker() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    document.querySelectorAll('.yotpo-page-element').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (trigger.classList.contains('yotpo-disabled')) {
          return;
        }
        yotpoReviews.style.visibility = 'hidden';
        const checkReviewsLoading = setInterval(() => {
          const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
          if (yotpoReviewsList != null && yotpoReviewsList.length > 0 && !yotpoReviewsList[0].classList.contains('swiper-slide')) {
            rejigReviews();
            mySwiper = makeSwiper();
            disableSwiperOnDesktop();
            yotpoReviews.style.visibility = 'visible';
            clearInterval(checkReviewsLoading);
            reviewLoadedChecker();
          }
        }, 50);
      });
    });
  }

  const breakpoint = window.matchMedia('(min-width: 750px)');
  breakpoint.addListener(disableSwiperOnDesktop);

  function disableSwiperOnDesktop() {
    if (!isProductTemplate) { return; }
    const swiperContainer = document.querySelector('[data-product-reviews-swiper-container]');
    if (swiperContainer === null) { return; }

    if (breakpoint.matches === true) {
      if (mySwiper !== null && typeof mySwiper !== 'undefined') {
        swiperContainer.classList.add('destroyed');
        mySwiper.destroy(true, true);
        mySwiper = null;
      }
    } else {
      initSwiper(swiperContainer);
      swiperContainer.classList.remove('destroyed');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  yotpoSliderInit();
});

function customCollectionSorting() {
  const collections = document.querySelectorAll('[data-custom-collection]');

  collections.forEach(collection => {
    const collectionGrid = collection.querySelector('[data-custom-collection-grid]');
    const collectionItems = collection.querySelectorAll('[data-collection-item]');
    const collectionFilterTags = collection.querySelectorAll('[data-collection-filter-tag]');

    if (!collectionFilterTags || !collectionItems) { return; }

    collectionFilterTags.forEach(collectionFilterTag => {
      const tag = collectionFilterTag.dataset.collectionFilterTag;

      collectionFilterTag.addEventListener('click', () => {
        const matchingItems = [...collectionItems].filter(item => item.dataset.collectionItemTags.includes(tag));

        setTimeout(() => {
          if (tag === 'all') {
            collectionGrid.classList.remove('filtered');
          } else {
            collectionGrid.classList.add('filtered');
          }
        }, 500);

        collectionFilterTags.forEach(button => button.classList.remove('selected'));
        collectionFilterTag.classList.add('selected');

        matchingItems.forEach(matchingItem => {
          matchingItem.classList.add('match');
        });

        if (matchingItems.length < 1) { return; }

        collectionGrid.classList.add('fadeout');
      });
    });

    collectionGrid.addEventListener('transitionend', (event) => {
      if (!event.target.classList.contains('collection-grid')) { return; }
      if (event.target.classList.contains('fadeout')) {
        collectionItems.forEach(collectionItem => {
          if (collectionItem.classList.contains('match')) {
            collectionItem.classList.remove('match', 'hide');
          } else {
            collectionItem.classList.add('hide');
          }
        });
        collectionGrid.classList.remove('fadeout');
      }
    });
  });
}

function customCollectionScroll() {
  const collectionItemBlocks = document.querySelectorAll('[data-collection-item-block-link]');
  const collectionWrap = document.querySelector('[data-collections-wrap]');

  // Scroll to section on page load
  if (collectionWrap.hasAttribute('data-scroll-to')) {
    const hashId = `#collection-${collectionWrap.getAttribute('data-scroll-to')}`;
    const section = document.querySelector(hashId);
    if (section) {
      setTimeout(() => {
        window.scrollTo({
          top: section.offsetTop,
          left: 0,
          behavior: 'smooth',
        });
      }, 100);
    }
  }

  // Scroll to section on click
  if (!collectionItemBlocks) { return; }

  collectionItemBlocks.forEach(block => {
    let currentWindowScroll = 0;

    block.addEventListener('mousedown', () => {
      currentWindowScroll = window.scrollY;
    });

    block.addEventListener('click', (event) => {
      event.preventDefault();
      window.scrollTo(0, currentWindowScroll);
      const hashId = block.getAttribute('href');
      const section = document.querySelector(hashId);
      section.scrollIntoView({behavior: 'smooth'});
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  customCollectionSorting();
  customCollectionScroll();
});

document.addEventListener('shopify:section:load', () => {
  customCollectionSorting();
  customCollectionScroll();
});

function homeVideoControls() {
  const homeVideo = document.querySelector('[data-custom-collection-video]');
  const homeVideoWrap = document.querySelector('[data-custom-collection-video-wrap]');
  const homePlayBtn = document.querySelector('[data-custom-collection-video-play-btn]');
  const homePauseBtn = document.querySelector('[data-custom-collection-video-pause-btn]');

  homePlayBtn.addEventListener('click', () => {
    handleVideoPlay();
  });

  homePauseBtn.addEventListener('click', () => {
    handleVideoPause();
  });

  const breakpoint = window.matchMedia('(min-width: 750px)');

  // eslint-disable-next-line func-style
  const breakpointChecker = () => {
    if (breakpoint.matches === true) {
      homeVideo.addEventListener('click', () => {
        if (homeVideoWrap.classList.contains('playing')) {
          handleVideoPause();
        } else {
          handleVideoPlay();
        }
      });
    } else if (breakpoint.matches === false) {
      homeVideo.addEventListener('click', () => {
        if (homeVideoWrap.classList.contains('playing') && !homeVideoWrap.classList.contains('mobile-hovered')) {
          homeVideoWrap.classList.add('mobile-hovered');
        } else if (homeVideoWrap.classList.contains('mobile-hovered')) {
          handleVideoPause();
        } else {
          handleVideoPlay();
        }
      });
    }
  };

  breakpoint.addListener(breakpointChecker);

  breakpointChecker();

  homeVideoWrap.addEventListener('mousemove', (event) => {
    setIdler(event);
  });

  homeVideoWrap.addEventListener('mouseout', () => {
    homeVideoWrap.classList.remove('idle');
  });

  function handleVideoPause() {
    homeVideo.pause();
    homeVideoWrap.classList.remove('playing', 'mobile-hovered', 'idle');
    homeVideoWrap.classList.add('paused');
  }

  function handleVideoPlay() {
    homeVideo.play();
    homeVideoWrap.classList.add('playing', 'played');
    homeVideoWrap.classList.remove('mobile-hovered', 'paused');
    setIdler();
  }

  let idleTimer = null;
  // eslint-disable-next-line no-unused-vars
  let idleState = true;

  function setIdler(event = null) {
    if (event !== null && event.target.hasAttribute('data-custom-collection-video-play-btn')) {
      clearTimeout(idleTimer);
      return;
    }

    homeVideoWrap.classList.remove('idle');
    clearTimeout(idleTimer);

    idleState = false;

    idleTimer = setTimeout(() => {
      if (homeVideoWrap.classList.contains('paused')) { return; }
      homeVideoWrap.classList.add('idle');
      idleState = true;
    }, 1000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  homeVideoControls();
});

document.addEventListener('shopify:section:load', () => {
  homeVideoControls();
});
